"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableBodyClassName: function() {
        return tableBodyClassName;
    },
    tableBodyClassNames: function() {
        return tableBodyClassNames;
    },
    useTableBodyStyles_unstable: function() {
        return useTableBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f1tp1avn"
    }
}, {
    d: [
        ".f1tp1avn{display:table-row-group;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const tableBodyClassName = 'fui-TableBody';
const tableBodyClassNames = {
    root: 'fui-TableBody'
};
const useTableBodyStyles_unstable = (state)=>{
    'use no memo';
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableBodyClassName, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
}; //# sourceMappingURL=useTableBodyStyles.styles.js.map
